<template>
    <div>
        <v-select :options="currencies"
                  :reduce="currency => currency.code"
                  label="code"
                  :value="userCurrency"
                  :clearable="false"
                  @input="changeCurrency">
        </v-select>
    </div>
</template>

<script>
    import vSelect from 'vue-select'

    export default {
        name: "ChangeCurrency",
        props: {
            currencies: {
                type: Array,
                required: true,
            },
            userCurrency: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                chosenCurrency: null,
            }
        },
        components: {
            vSelect
        },
        methods: {
            changeCurrency(value) {
                let currencyId = this.getChosenCurrency(value).id;

                axios.post('/site/change-currency/' + currencyId).then(res => {
                    window.location.reload();
                }).catch(error => {
                    Sentry.captureException(error);
                });
            },
            getChosenCurrency(code) {
                return this.currencies.find(currency => currency.code === code);
            }
        },
    }
</script>
